import { Component, output, signal } from '@angular/core';

@Component({
  selector: 'lib-drop-zone',
  imports: [],
  template: ` <div
    class="transition"
    [class.bg-sky-50]="dragging()"
    [class.outline]="dragging()"
    [class.outline-2]="dragging()"
    [class.outline-dashed]="dragging()"
    [class.outline-sky-300]="dragging()"
    [class.-outline-offset-2]="dragging()"
    (dragover)="onDragOver($event)"
    (dragleave)="dragging.set(false)"
    (drop)="onDrop($event)"
  >
    <ng-content></ng-content>
  </div>`,
})
export class DropZone {
  readonly dropped = output<DragEvent>();

  protected readonly dragging = signal(false);

  protected onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.dragging.set(true);
  }

  protected onDrop(event: DragEvent): void {
    event.preventDefault();
    this.dragging.set(false);
    this.dropped.emit(event);
  }
}
